let protocol = window.location.protocol;

let pointPosition = window.location.hostname.indexOf('.');
let subdomain = window.location.hostname.substr(0, pointPosition > 0 ? pointPosition : undefined);
let apiSubdomain = subdomain + '-api';
let apiHost = window.location.hostname.replace(subdomain, apiSubdomain);
let withDev = '';

if (window.location.hostname.indexOf('cobweb') !== -1) {
    withDev = '/app_dev.php';
}

if (window.location.hostname === 'localhost') {
    withDev = '/app_dev.php';
    apiHost = 'ampsec.ddev.site';
    protocol = 'https:'
}

export const GRAPHQL_ROUTE = protocol + '//' + apiHost + withDev + '/fetch';
export const API_ROUTE = protocol + '//' + apiHost + withDev;



// WEBPACK FOOTER //
// ./src/constants/ajaxRoutes.js